import { computed } from 'vue'
import { z } from 'zod'

import { usePageStore } from '@toni/rendering/src/stores/page'

const disallowAdsSchema = z.object({
  disallowAds: z.boolean().nullish(),
  disallowNativeTeasers: z.boolean().nullish(),
  disallowOutstream: z.boolean().nullish(),
  disallowTaboola: z.boolean().nullish()
})

export function useDisallowAds () {
  const pageStore = usePageStore()

  return computed(() => {
    const disallowAds = pageStore.pageData.metaData.disallowAds
    const disallowNativeTeasers = pageStore.pageData.metaData.disallowNativeTeasers
    // Map disallowPosterAds to disallowOutstream
    const disallowOutstream = pageStore.pageData.metaData.disallowPosterAds
    const disallowTaboola = pageStore.pageData.metaData.disallowTaboola

    const parsed = disallowAdsSchema.safeParse({
      disallowAds,
      disallowNativeTeasers,
      disallowOutstream,
      disallowTaboola
    })

    if (!parsed.success) {
      console.error(parsed.error)
      return {
        disallowAds: null,
        disallowNativeTeasers: null,
        disallowOutstream: null,
        disallowTaboola: null
      }
    }

    return parsed.data
  })
}
